import React, { useEffect, useState } from 'react'
import { Select, message as $message } from 'antd'
import { queryAllSupplierFixedCity } from '@/services/supplier'
import { queryAllChannelFixedCity } from '@/services/channel'

export default ({ value, type, onChange, ...restProps }) => {
    const [options, setOptions] = useState([])

    const load = async () => {
        const { success, message, data } =
            type === 'supplier' ? await queryAllSupplierFixedCity() : await queryAllChannelFixedCity()
        if (success) {
            setOptions(data)
        } else {
            $message.error(message)
        }
    }

    useEffect(() => {
        load()
    }, [])

    return (
        <Select
            showSearch
            allowClear
            mode="multiple"
            maxTagCount="responsive"
            value={value}
            onChange={onChange}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            {...restProps}>
            {options.map((item, index) => (
                <Select.Option key={index} value={item}>
                    {item}
                </Select.Option>
            ))}
        </Select>
    )
}
